import React, { useEffect, useState } from "react";
import axios from "axios";
import { Redirect } from "react-router-dom";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import Header from "../../../components/Header";
import SubHeader from "../../../components/SubHeader";
import { UserConsumer } from "../../../UserContext";
import SelectCriteriaForm from "./SelectCriteriaForm";
import { Routes } from "../../../configurations/config";
import { Table } from "../../../components/CustomPaginations";
import { tableStyle, dateCol } from "../../../components/TableStyle";
import { EmployeeWorkStatus_API } from "./EmployeeWorkStatus_API";
import { GlobalPaginationSize } from "../../../components/GlobalPaginationSize";

function EmployeeWorkStatus() {
	let token = null;
	const defaultSorted = [
		{
			dataField: "statusStartDate",
			order: "desc",
		},
	];
	const [pageNum, setPageNum] = useState(1);
	const [pagerData, setPagerData] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [sortBy, setSortBy] = useState(defaultSorted[0]);
	const [apiTokenHeader, setApiTokenHeader] = useState(null);
	const [supervisorsEmpList, setSupervisorsEmpList] = useState(null);
	const [selectedSupEmp, setSelectedSupEmp] = useState(null);
	const [employeeWorkStatusData, setemployeeWorkStatusData] = useState([]);
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(
		GlobalPaginationSize.AdminPaginationSize
	);

	const getColumns = [
		{
			dataField: "employeeId",
			text: "Employee ID",
			sort: true,
		},
		{
			dataField: "employeeName",
			text: "Employee Name",
			sort: true,
		},
		{
			dataField: "statusStartDate",
			text: "Start Date",
			sort: true,
			formatter: dateCol,
		},
		{
			dataField: "statusEndDate",
			text: "End Date",
			sort: true,
			formatter: dateCol,
		},
		{
			dataField: "status",
			text: "Status",
		},
	];

	useEffect(() => {
		const header = { Authorization: `Bearer ${token}` };
		//get Supervisor Employee List
		axios
			.get(`${EmployeeWorkStatus_API.GetSupervisorsEmployeesList}`, {
				headers: header,
			})
			.then(({ status, data }) => {
				if (status === 200) {
					const supEmpList = data.map((obj) => {
						return { value: obj.employeeId, label: obj.name };
					});
					supEmpList.unshift({ value: 0, label: "All" });
					setSupervisorsEmpList(
						supEmpList.sort((a, b) =>
							a.label.localeCompare(b.label)
						)
					);
					setSelectedSupEmp({ value: 0, label: "All" });
				}
			});
		//get default Table pagination Data
		axios
			.get(
				`${EmployeeWorkStatus_API.GetEmployeeWorkStatusPagination}?EmployeeId=0&PageSize=${numberOfItemsPerPage}&PageNumber=${pageNum}&SortBy=${sortBy.dataField}_${sortBy.order}`,
				{
					headers: header,
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setemployeeWorkStatusData(res.data.employeeWorkStatus);
				}
			});
		setApiTokenHeader(header);
	}, []);

	const updateTableData = (employee) => {
		//call api on Filtering table Data
		setIsLoading(true);
		axios
			.get(
				`${EmployeeWorkStatus_API.GetEmployeeWorkStatusPagination}?EmployeeId=${employee}&PageSize=${numberOfItemsPerPage}&PageNumber=${pageNum}&SortBy=${sortBy.dataField}_${sortBy.order}`,
				{
					headers: apiTokenHeader,
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setemployeeWorkStatusData(res.data.employeeWorkStatus);
				}
			});
	};

	const receiveData = (PageSize) => {
		//call api on table page size changed

		setIsLoading(true);
		axios
			.get(
				`${
					EmployeeWorkStatus_API.GetEmployeeWorkStatusPagination
				}?EmployeeId=${
					selectedSupEmp.value
				}&PageSize=${PageSize}&PageNumber=${1}&SortBy=${
					sortBy.dataField
				}_${sortBy.order}`,
				{
					headers: apiTokenHeader,
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setNumberOfItemsPerPage(PageSize);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setemployeeWorkStatusData(res.data.employeeWorkStatus);
				}
			});
	};

	const handleTableChange = (type, { page, sortOrder, sortField }) => {
		//call api on table sorting and pagination
		setIsLoading(true);
		let getData = false;
		let apiURL = "";

		if (type === "sort") {
			apiURL = `${EmployeeWorkStatus_API.GetEmployeeWorkStatusPagination}?EmployeeId=${selectedSupEmp.value}&PageSize=${numberOfItemsPerPage}&PageNumber=${page}&SortBy=${sortField}_${sortOrder}`;
			setSortBy({ dataField: sortField, order: sortOrder });
			getData = true;
		} else if (type === "pagination") {
			apiURL = `${EmployeeWorkStatus_API.GetEmployeeWorkStatusPagination}?EmployeeId=${selectedSupEmp.value}&PageSize=${numberOfItemsPerPage}&PageNumber=${page}&SortBy=${sortBy.dataField}_${sortBy.order}`;
			getData = true;
		}

		if (getData) {
			axios
				.get(apiURL, {
					headers: apiTokenHeader,
				})
				.then((res) => {
					if (res.status === 200) {
						setIsLoading(false);
						setPageNum(page);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
						setemployeeWorkStatusData(res.data.employeeWorkStatus);
					}
				});
		}
	};

	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return userDetails.empRole.includes("3") ? ( //authorization
					<>
						<div className="container-fluid pl-3 pr-3">
							<Header title="Employee Work Status" />
							<hr />

							<SubHeader
								btnTitle="Add New"
								icon={faPlus}
								linkTo={Routes.AdminAddEmployeeWorkStatusForm}
							/>

							{/* Filteration Form */}
							<SelectCriteriaForm
								supervisorsEmpList={supervisorsEmpList}
								selectedSupEmp={selectedSupEmp}
								onSupEmpChange={(value) => {
									setSelectedSupEmp(value);
									updateTableData(value.value);
								}}
							/>

							{/* Table with Pagination */}
							<PaginationProvider
								pagination={paginationFactory({
									custom: true,
									totalSize: pagerData
										? pagerData.TotalCount
										: 0,
									page: pageNum,
									sizePerPage: numberOfItemsPerPage,
									paginationSize: numberOfItemsPerPage,
								})}
							>
								{({
									paginationProps,
									paginationTableProps,
								}) => {
									return (
										<Table
											inputValue={""}
											keyField={"id"}
											columns={getColumns}
											items={employeeWorkStatusData}
											tableStyle={tableStyle}
											paginationProps={paginationProps}
											paginationTableProps={
												paginationTableProps
											}
											onTablePageChange={
												handleTableChange
											}
											defaultSorted={defaultSorted}
											showFeedback={false}
											tableLoader={isLoading}
											SearchBar={() => {
												return null;
											}}
											pagerData={pagerData}
											receiveData={(PageSize) => {
												receiveData(PageSize);
											}}
										/>
									);
								}}
							</PaginationProvider>
						</div>
					</>
				) : (
					<Redirect to="/MyDashboard" /> //redirection
				);
			}}
		</UserConsumer>
	);
}

export default EmployeeWorkStatus;
